import { GenericObject } from '@dxb-web-ui-framework/common/types';
import { PreloadedFormData } from '../../contexts/ClientSideWizard/types';

const wizardFormBuilderPreloadDataAdapter = (preloadedData?: PreloadedFormData): PreloadedFormData => {
  if (!preloadedData) {
    return null;
  }

  const normalizedPreloadedData = {} as GenericObject;

  if (preloadedData) {
    const preloadedDataValues = Object.values(preloadedData) as { stepId: string; values: GenericObject }[];
    for (const { values } of preloadedDataValues) {
      const preloadedValueEntries = Object.entries(values);
      for (const [key, preloadedValue] of preloadedValueEntries) {
        normalizedPreloadedData[key] = preloadedValue;
      }
    }
  }

  return normalizedPreloadedData;
};

export { wizardFormBuilderPreloadDataAdapter };
